import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { KONTRACTOR_API } from '../../../common/utils/api.bobcat';

@Component({
  selector: 'verticalSelectImageBox',
  templateUrl: './verticalSelectImageBox.component.html',
  styleUrls: ['./verticalSelectImageBox.component.scss']

})
export class VerticalSelectImageBoxComponent implements OnInit {

  @Input() object;
  @Input() valueSelected: string | Array<string> = null;
  @Output() selectElement = new EventEmitter();

  public baseHref = KONTRACTOR_API.baseHref;
  constructor() { }

  ngOnInit() {
  }
  selectObject(value) {
    this.selectElement.emit(value);
  }

  isSelected(value) {
    if (this.valueSelected instanceof Array) {
      return (this.valueSelected.indexOf(value) != -1);
    }
    else {
      return (this.valueSelected == value);
    }
  }
}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/utils/verticalSelectImageBox/verticalSelectImageBox.component.ts